import { render, staticRenderFns } from "./RequestDetail.vue?vue&type=template&id=27871abf&scoped=true"
import script from "./RequestDetail.vue?vue&type=script&lang=ts"
export * from "./RequestDetail.vue?vue&type=script&lang=ts"
import style0 from "./RequestDetail.vue?vue&type=style&index=0&id=27871abf&prod&scoped=true&lang=scss"
import style1 from "./RequestDetail.vue?vue&type=style&index=1&id=27871abf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27871abf",
  null
  
)

export default component.exports